import cookieJs from "js-cookie";
import { useEffect, useState } from "react";
import instance from "../axios_setup/instance";
const useGetDetailes = () => {
  const [userDetailes, setUserDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      const token = cookieJs.get("furniture_shop");
      if (token) {
        try {
          setLoading(true);
          const { data } = await instance.get("/isValid", {
            headers: {
              token,
            },
          });
          setLoading(false);
          if (!data.errors) {
            setUserDetails(data.payload);
          }
        } catch (err) {
          setLoading(false);
          setError(err.message);
        }
      }
    };
    check();
  }, []);
  return {
    userDetailes,
    error,
    loading,
  };
};
export { useGetDetailes };

